import { FC, useEffect, useState } from 'react'
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  makeStyles,
  MobileStepper,
  Typography,
} from '@perk-ui/core'

import BrandLogo from '../../../assets/BrandLogo.png'
import ArianaDeMers from '../../../assets/testimonials/ArianaDeMers.png'
import JhonKnab from '../../../assets/testimonials/JhonKnab.png'
import JhonRSantaAna from '../../../assets/testimonials/JhonRSantaAna.png'
import ThomasNabity from '../../../assets/testimonials/ThomasNabity.png'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(6),
    color: '#1B3A52',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3),
    },
  },
  logo: {
    marginBottom: theme.spacing(4),
    '& img': {
      height: '40px',
      width: 'auto',
    },
  },
  welcomeTitle: {
    fontFamily: '"DM Sans"',
    fontSize: '2.62em',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '1.111',
    fontFeatureSettings: '"liga" off, "clig" off',
    marginBottom: theme.spacing(4),
    color: 'var(--Neutrals-Text, #212121)',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.25em',
    },
  },
  carrouselContainer: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
  },
  carrouselInnerContainer: {
    minHeight: '180px',
  },
  carrouselStepper: {
    padding: theme.spacing(1, 0, 0, 0),
    background: 'none',
  },
  testimonialContainer: {
    display: 'flex',
    flexDirection: 'column',
    background: 'none',
    boxShadow: 'none',
    padding: 0,
    animation: '$fadeIn 0.5s ease-in',
  },
  testimonialHeader: {
    padding: theme.spacing(1, 0, 0, 0),
    '& .MuiCardHeader-title': {
      fontSize: '16px',
      fontWeight: 600,
      color: '#1B3A52',
    },
    '& .MuiCardHeader-subheader': {
      fontSize: '14px',
      opacity: 0.8,
      color: '#1B3A52',
    },
  },
  testimonialContent: {
    padding: 0,
    fontSize: '18px',
    fontStyle: 'italic',
    lineHeight: 1.6,
    color: '#1B3A52',
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
}))

const testimonials = [
  {
    title: 'Thomas Nabity, MD',
    image: ThomasNabity,
    content:
      'Partnering with DataBiologics is one of the ways our clinic is doing our part to leverage the most forward thinking treatment options possible.',
    clinic: 'Michigan Center for Regenerative Medicine Rochester, MI',
  },
  {
    title: 'John Knab, MD',
    image: JhonKnab,
    content:
      "The responsiveness of the team at DataBiologics is unparalleled. To me this is like having a personalized research team at your fingertips! I am happy to have finally found my 'forever registry' in DataBiologics.",
    clinic: 'Center for Pain Management Wilmington, NC',
  },
  {
    title: 'John R. Santa Ana, DO, FAAPMR',
    image: JhonRSantaAna,
    content:
      "My credibility is on the line with every consult and with every procedure. Having data to back up patient discussions and consultations helps me present their options better and in-turn earn patients' trust. Data separates Regenerative Medicine Physicians from hobbyists.",
    clinic: 'Michigan Center for Regenerative Medicine, Rochester, MI',
  },
  {
    title: 'Ariana DeMers DO, RMSK',
    image: ArianaDeMers,
    content:
      "I have been using DataBiologics for the last two years... I appreciate the wide access to outcomes across the nation for benchmarking, and to be able to convey expectations for outcomes for my patients. I think it's important to track your own data to make sure your patient outcomes are optimized.",
    clinic:
      'Joint Vitality Institute at Restore Orthopedics and Sports Medicine Sonora, CA',
  },
]

const CreateAccountBanner: FC = () => {
  const classes = useStyles()
  const [activeStep, setActiveStep] = useState(0)
  const maxSteps = testimonials.length

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % maxSteps)
    }, 10000)
    return () => clearInterval(timer)
  }, [maxSteps])

  const current = testimonials[activeStep]

  return (
    <Box className={classes.root}>
      <Box className={classes.logo}>
        <img src={BrandLogo} alt="DataBiologics" />
      </Box>

      <Typography className={classes.welcomeTitle}>
        Welcome to the future of optimizing care
      </Typography>

      <Box className={classes.carrouselContainer}>
        <Box className={classes.carrouselInnerContainer}>
          <Card key={activeStep} className={classes.testimonialContainer}>
            <CardContent className={classes.testimonialContent}>
              {`"${current.content}"`}
            </CardContent>
            <CardHeader
              className={classes.testimonialHeader}
              avatar={<Avatar src={current.image} alt={current.title} />}
              title={current.title}
              subheader={current.clinic}
            />
          </Card>
        </Box>
        <MobileStepper
          className={classes.carrouselStepper}
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          nextButton={null}
          backButton={null}
        />
      </Box>
    </Box>
  )
}

export default CreateAccountBanner
